module.exports = __webpack_public_path__ + "img/kfc.b6a825bd.png";